<template>
  <v-container
    fill-height
    fluid
  >
    <v-card class="col-12">
      <v-row class="mx-2 my-4" style="white-space: nowrap">
        <select-project
          v-model="project"
          class="report-base-filter"
          style="min-width: 200px"
        >
        </select-project>
        <v-select
          :items="dateRangeList"
          :value="dateRangeList[0]"
          label="Period"
          v-on:change="changeTimePeriod"
          hide-details
          class="report-base-filter"
          style="min-width: 150px"
        ></v-select>
        <date-picker
          v-model="from"
          label="Date From"
          style="max-width: 140px"
        />

        <date-picker
          v-model="to"
          label="Date To"
          style="max-width: 140px"
        />

        <v-btn color="info" v-on:click="search" class="mt-3 mr-3" :disabled="loading" :loading="loading">Search</v-btn>
        <div v-if="$store.state.auth.checkAccess({key: 'vip_statistic_export', value: true})" style="width:250px; margin-top: 3px;">
          <export :fields="['account_id']" :data="[{account_id: accountsId}]" v-if="items.length > 0">
            <template #custom="{exportData}">
              <v-btn @click="exportData('pdf')" color="yellow accent-1" :disabled="loading" :loading="loading">Export accounts id</v-btn>
            </template>
          </export>
        </div>
        <export :fields="exportFields(headers)" :data="items" v-if="items.length > 0" />
      </v-row>

      <v-data-table
        :headers="headers"
        :items="filteredItems"
        :loading="loading"
        :items-per-page="-1"
        item-key="row_key"
        hide-default-footer
        class="col-12 pa-0 vip_stats-dt"
        fixed-header
        height="calc(100vh - 140px)"
      >
        <template v-slot:body.prepend>
          <tr v-if="Object.keys(filters).length > 0" class="report-filter-row grey lighten-3">
            <td
              v-for="header in headers"
              :key="header.text"
            >
              <v-select
                v-if="filters.hasOwnProperty(header.value) && filters[header.value].type == 'select'"
                hide-details
                dense
                small
                multiple
                clearable
                persistent-hint
                single-line
                class="data-table-finance-filter-select"
                :items="filters[header.value].values || columnValueList(header.value)"
                :style="{width: (filters[header.value] || {width: false}).width}"
                v-model="filters[header.value].data"
              ></v-select>
              <v-text-field
                class="data-table-finance-filter-textfield"
                v-if="filters.hasOwnProperty(header.value) && filters[header.value].type == 'text'"
                v-model="filters[header.value].data"
                :style="{width: (filters[header.value] || {width: false}).width, 'min-width': (filters[header.value] || {width: false}).width}"
                hide-details
              ></v-text-field>
            </td>
          </tr>
        </template>

        <template v-slot:item.login="{ item }">
          <a :href="'/user-management/' + item.login " target="_blank">{{ item.login }}</a>
        </template>
        <template v-slot:item.row_num="{ item }">
          <span class="row_num"></span>
        </template>
        <template v-slot:item.last_login="{ item }">
          <span class="text-no-wrap">{{ item.last_login }}</span>
        </template>
        <template v-slot:item.last_deposit_date="{ item }">
          <span class="text-no-wrap">{{ item.last_deposit_date }}</span>
        </template>
        <template v-slot:item.comment="{ item }">
          <div style="min-width: 250px;">
            <v-textarea
              v-model="item.comment"
              auto-grow
              rows="1"
              hide-details
              append-icon="mdi-content-save"
              @click:append="saveComment(item)"
              class="pa-0 ma-0"
            ></v-textarea>
          </div>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<style>
  .vip_stats-dt thead th {
    white-space: nowrap;
  }

  .vip_stats-dt .v-select__selections {
    display: contents;
  }

  .vip_stats-dt tr:not(.report-filter-row) {
    counter-increment: row-num;
  }

  .vip_stats-dt tr td:first-child .row_num::before {
    content: counter(row-num) ". ";
  }

  .report-base-filter {
    padding: 12px 8px;
    -webkit-box-flex: 0;
    -ms-flex: 0 0 8.3333333333%;
    flex: 0 0 8.3333333333%;
    max-width: 8.3333333333%;
  }

  .data-table-finance-filter-select .v-select__selections {
    height: 32px;
    overflow: hidden;
    white-space: nowrap;
  }

  .data-table-finance-filter-select {
    max-width: 150px;
    font-size: 12px;
    padding: 0;
    margin: 0;
  }

  .data-table-finance-filter-textfield {
    max-width: 80px;
    font-size: 12px;
    padding: 0;
    margin: 0;
  }

  .vip_stats-sub-dt tr:not(.report-filter-row) {
    counter-increment: row-num;
  }

  .vip_stats-sub-dt tr td:first-child .row_num::before {
    content: counter(row-num) ". ";
  }

  .vip_stats-sub-dt.v-data-table th,
  .vip_stats-dt.v-data-table th {
    padding: 0 6px !important;
  }

  .v-data-table.vip_stats-sub-dt td,
  .v-data-table.vip_stats-dt td {
    height: 35px !important;
    padding: 3px 6px !important;
  }

</style>

<script>
  import { API } from '@/utils/api'
  import { debounce, get, map, toString } from 'lodash'
  import moment from 'moment'
  import Export from '@/components/helper/Export.vue'
  import SelectProject from '@/components/core/SelectProject/SelectProject.vue'
  import DatePicker from '@/components/core/DatePicker/DatePicker.vue'

  export default {
    components: { SelectProject, Export, DatePicker },
    props: {
      type_client: {
        type: String,
        default: 'vip'
      },
      itemFilter: {
        type: Function,
      }
    },
    data: () => ({
      dateRangeList,

      expanded: false,
      from: moment().format('YYYY-MM-DD'),
      to: moment().format('YYYY-MM-DD'),

      loading: false,
      headers: [
        { text: '#', value: 'row_num', sortable: false },
        { text: 'AccountID', value: 'account_id' },
        { text: 'Login', value: 'login' },
        { text: 'Currency', value: 'currency' },
        { text: 'Country', value: 'country' },
        { text: 'Language', value: 'language' },
        { text: 'Status', value: 'status', sortable: true },
        { text: 'Balance', sortable: false, value: 'balance', },
        { text: 'Last Login', sortable: false, value: 'last_login', },
        { text: 'LDD', value: 'last_deposit_date', sortable: true },
        { text: 'LDA', value: 'last_deposit_amount', sortable: true },
        { text: 'Total Deposit', value: 'total_deposit', sortable: true },
        { text: 'Average Deposit', value: 'total_deposit_average', sortable: true },
        { text: 'Total Withdraw', value: 'total_withdraw', sortable: true },
        { text: 'Total Bonus', value: 'total_bonus', sortable: true },
        { text: 'Total Bet', value: 'total_bet', sortable: true },
        { text: 'Average Bet', value: 'total_bet_average', sortable: true },
        { text: 'Total Win', value: 'total_win', sortable: true },
        { text: 'Total GGR', value: 'total_ggr', sortable: true },
        { text: 'Total NGR', value: 'total_ngr', sortable: true },
        { text: 'Comment', value: 'comment', sortable: true },
      ],
      filters: {
        account_id: { data: [], type: 'text', width: '75px' },
        login: { data: [], type: 'text', width: '150px' },
        currency: { data: [], type: 'select', width: '75px' },
        country: { data: [], type: 'select', width: '75px' },
        total_bet_average: { data: [], type: 'text', width: '75px' },
        total_deposit_average: { data: [], type: 'text', width: '75px' },
        status: { data: [], type: 'select', width: '75px' },
        total_deposit: { data: '', type: 'text', width: '75px' },
        language: { data: [], type: 'select', width: '75px' },

      },
      project: null,
      items: [],
      totalRows: [],
      totalRow: false,
    }),

    computed: {
      accountsId () {
        return this.items.map(({ account_id }) => account_id).join(',')
      },
      filteredItems: function () {
        return this.items.filter(d => {
          return Object.keys(this.filters).every(f => {
            try {
              if (this.filters[f].data.length > 1 && typeof this.filters[f].data == 'string' && this.filters[f].data.toString().match(/^[><=!]{1,2}/)) {
                let filter = this.filters[f].data
                if (this.filters[f].data.toString().match(/^[><=!]{1,2}/)[0] == '=') filter = '=' + this.filters[f].data
                return eval((get(d, f) || '0').toString() + filter)
              }
            } catch (e) {
              return true
            }
            return this.filters[f].data.length < 1
              || ((this.filters[f].data.includes((get(d, f) || '')) && toString((get(d, f) || '')).length > 0)
                || (this.filters[f].data.includes(true) && ((get(d, f) || '').toString().toLowerCase()).length > 0)
                || (this.filters[f].data.includes(false) && ((get(d, f) || '').toString().toLowerCase()).length == 0)
                || (typeof get(d, f) != 'boolean' && ((get(d, f) || '').toString().toLowerCase()).indexOf(this.filters[f].data.toString().toLowerCase()) >= 0))
          })
        })
      },
    },

    methods: {
      changeTimePeriod: function (value) {
        this.from = value.from
        this.to = value.to
      },
      exportFields (headers) {
        return map(headers, 'value')
      },
      saveComment: async function (item) {

        if (await this.$root.$confirm('Confirm', 'Save comment')) {
          return API.call('/$v/account/comments/update.json', {
            login: item.login,
            type: this.type_client,
            comment: item.comment,
            entity_id: this.project,
            vip_stats: 1,
          }, { login: item.login })
            .then(() => {
              this.$showSuccess('Comment saved successfully')
            })
            .catch(e => {
            })
        }
      },

      search () {
        this.loading = true

        setTimeout(() => {
          return API.call('/$v/reports/vip_stats.json', {
            from: this.from,
            to: this.to,
            type_client: this.type_client
          }, null, this.project).then(resp => {
            if (this.itemFilter) {
              this.items = resp.data.filter(this.itemFilter)
            } else {
              this.items = resp.data
            }
            return resp.data
          }).finally(() => {
            this.loading = false
          })
        }, 500)
      },

      columnValueList (val) {
        return this.items.map(d => d[val])
      }
    },
  }
</script>
